import React from "react";
import { Button, Modal } from "react-bootstrap";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import { toast } from "react-toastify";

function DeletePopup({ show, onClose, rfqId }) {
  const { loadingDelete, postData: deleteRecord } = usePostRequest(
    API_ENDPOINTS.DELETE_RECORD_RFQ
  );

  const deleteRecordById = (id) => {
    deleteRecord({ id: id }, onDeleteSuccess, onDeleteError);
  };

  const onDeleteSuccess = (res) => {
    toast.success(res?.message || "Record deleted successfully");
    // setPage({
    //   draft: 1,
    //   won: 1,
    //   lost: 1,
    //   pending: 1,
    //   cancelled: 1,
    // });
    // handleClearFilter();
  };

  const onDeleteError = (err) => {
    toast.error(err?.message || "Failed to delete the record");
  };

  return (
    <>
      <Modal show={show} onHide={onClose} centered>
        <Modal.Header
          className="justify-content-center d-block text-center"
          closeButton
        >
          <Modal.Title className="tittle_deal">
            <span className="text-danger">
              Are you sure you want to delete the opportunity with ID - {rfqId}
            </span>
          </Modal.Title>
          <p className="mb-0">
            Please provide the following information to create a pending order
            and start fulfilling it.
          </p>
        </Modal.Header>

        <Modal.Footer className="justify-content-center">
          <Button variant="warning" onClick={deleteRecordById(rfqId)} disabled={loadingDelete}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeletePopup;
